var matchHeight = function() {
  var $ = require('jquery');
  require('jquery-match-height');

  $(".post-item").matchHeight();
  $(".js-post-match").matchHeight();
  $(".js-contact").matchHeight({byRow:false});
  $(".property-category").matchHeight();
  $(".property-category__content").matchHeight();
  $(".property-category__title").matchHeight();
  $(".js-property-match").matchHeight();
}
module.exports = matchHeight;